<template>
  <mw-dialog :size="params.size?params.size:'small_small'" customClass="mw-dialog-tree-table" ref="dialog"
             :title="params.title?params.title:'选择'" :appendToBody="false" :footerButton="footerButton"
             :before-close="selectCancel">
    <split-pane :defaultPercent="params.defaultPercent?params.defaultPercent:50"
                v-if="!showSelected">
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-panel">
            <div class="mw-toolbar" v-if="params.showTreeToolbar==undefined?true:params.showTreeToolbar"
                 style="margin-right: 0px;margin-left: 0px;margin-bottom: 0px;">
              <mw-button @click="expand" icon="fa fa-angle-double-down">展开
              </mw-button>
              <mw-button @click="closed" icon="fa fa-angle-double-up">折叠
              </mw-button>
            </div>
            <div :class="[{'mw-toolbar__body':(params.showTreeToolbar==undefined?true:params.showTreeToolbar),
            'mw-panel-y':!(params.showTreeToolbar==undefined?true:params.showTreeToolbar)},'mw-app__edit']">
              <mw-tree style="padding-top:0px;" :url="params.url" :defaultParentId="params.defaultParentId"
                       :treeData="params.treeData" :async="(params.treeAsync==undefined?true:params.treeAsync)"
                       ref="tree" :expandedFirst="true" :selectFirst="params.selectFirst"
                       :defaultParams="params.treeDefaultParams" :changeDefaultParams="params.changeDefaultParams"
                       :multiple="false" @changed="changed"></mw-tree>
            </div>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <div class="mw-panel">
            <mw-table ref="dataTable" :columns="params.columns ? params.columns:columns" :defaultParamsAutoLoad="true"
                      :data="params.tableData" :autoLoad="params.autoLoad==undefined?false:params.autoLoad"
                      :pagination="false" :defaultParams="defaultParams"
                      :api="params.api" @select="select" @selectAll="selectAll" @rowClick="rowClick"
                      :singleSelect="params.singleSelect">
            </mw-table>
          </div>
        </div>
      </template>
    </split-pane>

    <split-pane :defaultPercent="params.defaultPercent?params.defaultPercent:30" v-else>
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-panel">
            <div class="mw-toolbar" v-if="params.showTreeToolbar==undefined?true:params.showTreeToolbar"
                 style="margin-right: 0px;margin-left: 0px;margin-bottom: 0px;">
              <mw-button @click="expand" icon="fa fa-angle-double-down">展开
              </mw-button>
              <mw-button @click="closed" icon="fa fa-angle-double-up">折叠
              </mw-button>
            </div>
            <div :class="[{'mw-toolbar__body':(params.showTreeToolbar==undefined?true:params.showTreeToolbar),
            'mw-panel-y':!(params.showTreeToolbar==undefined?true:params.showTreeToolbar)},'mw-app__edit']">
              <mw-tree style="padding-top:0px;" :url="params.url" :defaultParentId="params.defaultParentId"
                       :treeData="params.treeData" :async="(params.treeAsync==undefined?true:params.treeAsync)"
                       ref="tree" :expandedFirst="true" :selectFirst="params.selectFirst"
                       :defaultParams="params.treeDefaultParams" :changeDefaultParams="params.changeDefaultParams"
                       :multiple="false" @changed="changed"></mw-tree>
            </div>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <split-pane :defaultPercent="params.selectDefaultPercent?params.selectDefaultPercent:50">
          <template slot="paneL">
            <div class="mw-split-left">
              <mw-table ref="dataTable" :columns="params.columns ? params.columns:columns" :defaultParamsAutoLoad="true"
                        @selectChange="selectChange" :data="params.tableData"
                        :autoLoad="params.autoLoad==undefined?false:params.autoLoad" :pagination="false"
                        :defaultParams="defaultParams"
                        :api="params.api" @select="select" @dataLoaded="dataLoaded" @rendered="rendered" @selectAll="selectAll"
                        @rowClick="rowClick" :singleSelect="params.singleSelect">
              </mw-table>
            </div>
          </template>
          <template slot="paneR">
            <div class="mw-split-right">
              <div class="mw-panel">
                <mw-table ref="dataSelectTable" :columns="params.selectColumns ? params.selectColumns:selectColumns"
                          :pagination="false"
                          :data="tableSelectData">
                </mw-table>
              </div>
            </div>
          </template>
        </split-pane>
      </template>
    </split-pane>
  </mw-dialog>
</template>

<script>
  export default {
    props: {
      /**
       *  params.data
       *  url:  必须
       *  title:选择  （可选）
       *  size:mini_small    （可选）
       *  clearBtn: true为启用清除按钮，默认有
       *
       *  treeToolbar:true 树展开和折叠
       *
       *  buttonsScript: 额外处理按钮
       *  sureName: 确定按钮名称
       *  cancelName: 取消按钮名称
       */
      params: {
        type: Object
      }
    },
    data() {
      let me = this;
      return {
        showSelected:(me.params.showSelected == undefined ? false : me.params.showSelected),
        loaded: false,
        setVal:false,
        defaultParams: {},
        tableSelectData: me.params.tableSelectData == undefined ? [] : me.params.tableSelectData,
        selectTag:me.params.selectTag == undefined ? "id" : me.params.selectTag,
        api: '',
        columns: [{type: 'selection'},
          {prop: 'name', label: $lang('名称'), tooltip: true}],
        selectColumns: [
          {prop: 'name', label: $lang('名称'), tooltip: true}],
        footerButton: [
          {
            label: $lang(me.params.sureName || '确定'), func: this.selectSure,
          },
          {label: $lang(me.params.cancelName || '取消'), func: this.selectCancel, type: 'default'}

        ]
      }
    },
    created() {
      let me = this;
      if (me.params.buttonsScript)
        eval(me.params.buttonsScript);
      if (me.params.clearBtn == undefined || me.params.clearBtn) {
        this.footerButton.unshift({
          label: $lang('清除'),
          func: this.clearSure,
          type: 'default'
        })
      }
    },
    mounted() {
      setTimeout(() => {
        this.show();
      }, 200)
    },
    watch: {
      'params.url'() {
      }
    },
    methods: {
      dataLoaded: function (data) {
        let me = this;
        me.loaded = true;
      },

      rendered: function (data) {
        let me = this;
        me.tableSelectData.forEach(v=>{
          let idx = me.mwLodash.findIndex(data, function (o) {
            return o[me.selectTag] == v[me.selectTag]
          });
          if (idx > -1) {
            me.setVal=true;
            this.mwRef("dataTable").selectByProp([me.selectTag], v[me.selectTag])
          }
        })
      },

      selectChange: function (selection) {
        let me = this;
        if(me.setVal){
          me.setVal=false;
          return;
        }
        if (me.loaded) {
          me.loaded = false;
          if(selection.length == 0){
            return;
          }
        }

        if(me.params.singleSelect){
          if(me.tableSelectData.length>0){
            me.tableSelectData.splice(0, 1);
          }
        }

        if (me.showSelected) {
          let data = this.mwRef("dataTable").getData();
          data.forEach(v => {
            let idx = me.mwLodash.findIndex(selection, function (o) {
              return o[me.selectTag] == v[me.selectTag]
            });
            if (idx == -1) {
              idx = me.mwLodash.findIndex(me.tableSelectData, function (o) {
                return o[me.selectTag] == v[me.selectTag]
              });
              if (idx > -1) {
                me.tableSelectData.splice(idx, 1);
              }
            } else {
              idx = me.mwLodash.findIndex(me.tableSelectData, function (o) {
                return o[me.selectTag] == v[me.selectTag]
              });
              if (idx == -1) {
                me.tableSelectData.push(v);
              }
            }
          })
        }

      },

      selectAll: function (selection) {
        if (this.params.selectAll) {
          this.params.selectAll(selection);
        }
      },
      select: function (selection, row) {
        if (this.params.select) {
          this.params.select(selection, row);
        }
      },
      rowClick: function (row, event, column) {
        if (this.params.rowClick) {
          this.params.rowClick(row, event, column);
        }
      },
      expand() {
        this.mwRef('tree').openAll();
      },
      closed() {
        this.mwRef('tree').closeAll();
      },
      changed(data) {
        let me = this;
        if (me.params.changed) {
          me.params.changed.call(me, data, this.mwRef('tree'), this.mwRef('dataTable'));
        } else {
          this.defaultParams = me.params.defaultParams
        }
      },

      selectSure() {
        let me = this, data = me.mwRef('dataTable').getMultipleSelection();
        if(me.showSelected) {
          me.params.func(me.tableSelectData);
        }else{
          me.params.func(data);
        }
        me.selectCancel();
      },
      selectCancel() {
        this.mwRef('dialog').hide();
      },
      clearSure() {
        let me = this;
        this.mwRef('tree').unCheckAll();
        me.params.func([]);
        me.selectCancel();
      },
      show() {
        this.mwRef('dialog').show();
      }

    }
  }
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/components/treeTable.vue